import { PayloadAction } from "@reduxjs/toolkit";
import { Numbers } from "../../../common/constants/Number";
import {
  INotificationState, INotification } from "./Types";

/**
 * Function to insert new notification to Notifications Array
 */
const insertItem = (array: INotification[], item: INotification): INotification[] => {
  array = array.filter((notification: INotification) => notification.actionType !== item.actionType );
  const length = array.length;
  const newArray = array.slice();
  newArray.splice(length, Numbers.Zero, item);
  return newArray;
};


export const Reducer = {
  setNotificationOpen: (state: INotificationState, action: PayloadAction<INotification>): INotificationState => {
    return {
      ...state,
      notificationItems: insertItem(state.notificationItems, action.payload)
    };
  },
  setNotificationClose: (state: INotificationState, action: PayloadAction<INotification>): INotificationState => {
    return {
      ...state,
      notificationItems: state.notificationItems.filter((item: INotification) =>
        item.id !== action.payload.id)
    };
  },
  clearAllNotifications: (state: INotificationState): INotificationState => {
    return {
      ...state,
      notificationItems: []
    };
  }
};
